import type { Merge } from '@festina-life/core'

import type { RankedItem } from '../../components/search/commandPalette/types'
import { useCommandPaletteLocalStorage } from '../../components/search/commandPalette/useCommandPaletteLocalStorage'
import { processCategoryGroup } from '../../components/search/commandPalette/utils'
import { useHook } from '../../lenteHooks'
import { useSearch } from './useSearch'
export type NavigationItem = Merge<RankedItem, { action: string }>

export const useNavigationItems = () => {
  const navigationItems = useSearch({ searchTerm: '' }).filter(
    (item) => item.group === 'navigation',
  )
  const categories = useHook('routing.search.useSearchCategories')()
  const [favourites] = useCommandPaletteLocalStorage()

  return processCategoryGroup({
    group: 'navigation',
    categories: categories.navigation,
    options: navigationItems,
    shouldSortOnTitle: false,
    ...favourites['navigation'],
  })
}
